export default __webpack_public_path__ + "static/media/profile.22888246.svg";